import React from 'react';
import WidgetResourcesInPlaceState from '../WidgetResourcesInPlace/WidgetResourcesInPlaceState';
import WidgetResourcesInHourState from '../WidgetResourcesInHour/WidgetResourcesInHourState';

const DashboardState = ({ children }) => {

    return (
        <WidgetResourcesInPlaceState>
            <WidgetResourcesInHourState>
                {children}
            </WidgetResourcesInHourState>
        </WidgetResourcesInPlaceState>
    )
}

export default DashboardState